import API from "../../api";
import {
  API_REGISTER_INSPECTION,
  API_REGISTER_TEMPORARY_INSPECTION,
  API_CHANGE_MACHINE_TEMPLATE
} from "../../constants/api";

const getInformationInspection = async (templateId, machineId) => {
  try {
    const response = await API.get(API_REGISTER_INSPECTION(templateId, machineId));
    return response.data;
  } catch (e) {
    throw e.response;
  }
};

const register = async (templateId, machineId, data) => {
  try {
    const response = await API.post(API_REGISTER_INSPECTION(templateId, machineId), data);
    return response.data;
  } catch (e) {
    throw e.response;
  }
};

const changeMachineSelect = async (templateId, data) => {
  try {
    const response = await API.get(API_CHANGE_MACHINE_TEMPLATE(templateId), {
      params: data
    });
    return response.data;
  } catch (e) {
    throw e.response;
  }
};

const changeMachineInput = async (templateId, data) => {
  try {
    const response = await API.post(API_CHANGE_MACHINE_TEMPLATE(templateId), data);
    return response.data;
  } catch (e) {
    throw e.response;
  }
};


const registerTemporary = async (templateId, machineId, data) => {
  try {
    const response = await API.post(API_REGISTER_TEMPORARY_INSPECTION(templateId, machineId), data);
    return response.data;
  } catch (e) {
    throw e.response;
  }
};


const RegisterInspection = {
  getInformationInspection,
  register,
  registerTemporary,
  changeMachineSelect,
  changeMachineInput
};

export {
  RegisterInspection as default,
  getInformationInspection,
  register,
  registerTemporary,
  changeMachineSelect,
  changeMachineInput
}